import { Helmet } from 'react-helmet';
import MediaTable from './MediaTable';

function MediaBody() {
  return (
    <div className="media__container">
      <Helmet>
        <meta charSet="utf-8" />
        <title>라이프스팬 - 미디어자료</title>
      </Helmet>
      <div className="media__wrapper column">
        <div className="media__title">
          <h1>미디어자료</h1>
          <h3>
            * 본 페이지에 올라온 자료는 라이프스팬 제품의 공식 판매자들을 위한
            것입니다.
            <br /> 허가받지 않은 사람이 무단으로 사용할 경우 법적 책임을 질 수
            있습니다.
          </h3>

          <h6>* 사진을 클릭하시면 큰 사이즈로 보실 수 있습니다. </h6>
        </div>
      </div>
      <MediaTable />
    </div>
  );
}

export default MediaBody;
